import mobileDetectFn from 'is-mobile';

export function useMobileDetection() {
	const isMobile = mobileDetectFn;

	return { isMobile }
}
